// Modelo Vacuna para administrador.
export default class Vaccine {
    id=""
    name=""
    duration=""
}



// WEBPACK FOOTER //
// ./src/model/Vaccine.js